import { render, staticRenderFns } from "./DesignationArchive.vue?vue&type=template&id=6b063eac&"
import script from "./DesignationArchive.vue?vue&type=script&lang=js&"
export * from "./DesignationArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports